/**
 * Extrai data/hora do nome do arquivo de imagem de infração.
 * Ex.: CENTRO_FREI SERAFIM X R.ACRE - FIXA 01 (02-09-2026_14-01-54.217).jpg
 */
const FILENAME_DATETIME_PATTERNS = [
  /\((\d{2})-(\d{2})-(\d{4})_(\d{2})-(\d{2})-(\d{2})(?:\.(\d{1,3}))?\)/,
  /(?<!\d)(\d{2})-(\d{2})-(\d{4})_(\d{2})-(\d{2})-(\d{2})(?:\.(\d{1,3}))?(?!\d)/,
  /(\d{2})\/(\d{2})\/(\d{4})[ T_](\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?/
];

const padMs = (raw) => {
  if (!raw) return 0;
  const digits = String(raw).slice(0, 3);
  return Number.parseInt(digits.padEnd(3, '0'), 10);
};

export const parseInfractionFilenameDate = (filename) => {
  if (!filename) return null;

  const baseName = String(filename).split(/[\\/]/).pop() || '';

  for (const pattern of FILENAME_DATETIME_PATTERNS) {
    const match = baseName.match(pattern);
    if (!match) continue;

    const day = Number.parseInt(match[1], 10);
    const month = Number.parseInt(match[2], 10);
    const year = Number.parseInt(match[3], 10);
    const hour = Number.parseInt(match[4], 10);
    const minute = Number.parseInt(match[5], 10);
    const second = Number.parseInt(match[6], 10);
    const ms = padMs(match[7]);

    if (
      month < 1 || month > 12 ||
      day < 1 || day > 31 ||
      hour > 23 || minute > 59 || second > 59
    ) {
      continue;
    }

    const date = new Date(year, month - 1, day, hour, minute, second, ms);
    if (Number.isNaN(date.getTime())) continue;

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      continue;
    }

    return date;
  }

  return null;
};

export const toDatetimeLocalValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const fromDatetimeLocalValue = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
